"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.thenable = void 0;
// returns true if the given value is a thenable object
function thenable(o) {
    return o !== undefined && o !== null && typeof o.then === 'function';
}
exports.thenable = thenable;
